import React from "react";
import { useForm } from "./FormContext";

const Journey = (onOpen) => {
  const { openForm } = useForm();
  return (
    <>
      <section className="animate Journey">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12" style={{ width: "100%" }}>
              <h2 className="text-center text-white mb-0">
                Your Journey Starts Here
              </h2>
              <p className="text-center text-white mb-0">
                Meaningful change begins with a single step. <br /> You already
                have the answers within you - this journey helps you uncover
                them and move forward with clarity and confidence.
              </p>
              <button
                type="button"
                className="btn-new mt-3"
                onClick={() =>
                  openForm({
                    service_title: "Free Discovery Call",
                    duration: "15 minutes",
                    format: "Online",
                  })
                }
                style={{
                  borderColor: "#fff",
                  cursor: "pointer",
                  display: "block",
                  margin: "0 auto",
                }}
              >
                Book Your Free Discovery Call
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Journey;
